// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateProductColor_cancelButton__29k20"};